module.exports = __webpack_public_path__ + "img/step3_online.419fdc7d.png";